import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
import { ActivatedRoute } from '@angular/router';
declare var $: any;
import Swal from 'sweetalert2/dist/sweetalert2.js';
declare let swal:any;
@Component({
  selector: 'app-editbreedsmanagement',
  templateUrl: './editbreedsmanagement.component.html',
  styleUrls: ['./editbreedsmanagement.component.css']
})
export class EditbreedsmanagementComponent implements OnInit {
  returnUrl= "/dashboard/breedsmanagement";
  getbreedseditApi:any;
  addUrl:any;
  putbreedseditApi:any;
  editbreedsFormValue:any;
  getlistApi:any;
  getspeciesListData:any;
  getfarmlistApi:any;
  loadspeciesValue:any;
  getfarmlistdata:any;
  speciesloaddata:any;
  speciesloadid:any;
  loginresponse:any;
  farmidhavesamespecies:any=[];
  selectallvalue:any;
  getfarmdata:any;
  result:any;
  userrole:any;
  optionVal1:any;
  speciesprimaryid:any;
  speciesIDprepop:any;
  farm_userrole:any;
  cby_mby:any;
  getspecieslistApi:any;
  speciesloadidlooping:any=[];
  resultcond:any;
  isLoading:boolean=false;
  constructor(private router: Router,private commonService: CommonService) { 
 
    
  }

  async ngOnInit(): Promise<void> {
    this.isLoading=true;
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby=this.loginresponse.user_id;
    this.userrole=this.loginresponse.read_status;
    this.farm_userrole=this.loginresponse.user_farm_id;
    if(this.farm_userrole){
      $("#farmname").attr("disabled","disabled")
    }
    $('.selectpicker').selectpicker('refresh');
    console.log(this.getfarmlistdata);
       
    let breedsId = sessionStorage.getItem('breedsId');
    this.getbreedseditApi= "/breeds/"+ breedsId;
    this.putbreedseditApi= "/breeds/"+ breedsId;
    (await this.commonService.getApi(this.getbreedseditApi)).subscribe(
     async res => {
      var getfarmid=res.data.farm_id.split(",");
      this.resultcond=getfarmid.length;
    this.speciesloadidlooping =getfarmid.map((num)=>{
        return {farmloadid:num};
      });
   
      this.speciesloadid=res.data.farm_id;
     var speciesid= res.data.species_id;
    var speciesname=res.data.species_name;
    //---------------http://18.116.99.161/api/farms/checkfarm_status/list?species_id=404
    ///////////////////code need to change here...................
    this.getlistApi="/farms/checkfarm_status/list?species_id="+speciesid;
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      async (res) => {       
        setTimeout(() => {
          this.getfarmlistdata = res.data; 
          $(function() {  
                  $('#farmname').multiselect({
                    buttonText: function (options) {
                      if (options.length == 0) {
                          return ' None selected ';
                      } else {
                          var selected = 0;
                          options.each(function () {
                              selected += 1;
                          });
                          return selected +  ' Selected ';
                      }
                  },
                         
                             includeSelectAllOption: true,
                             enableFiltering: true,
                             enableCaseInsensitiveFiltering: true,
                             filterPlaceholder: 'Search for something...',
                             onChange:function(option, checked, select) {
                             this.selectedmultidata= $('#farmname').val();
                             console.log(  this.selectedmultidata);
                            
                           }
                           
                         }); 
                 });
                 this.isLoading=false;
        },1000);
      })
///////////////////code need to change here...................

    //------------
            this.loadspeciesValue={
              "farms_id":this.speciesloadid
            }
           // this.addUrl = "/species/farms";
           this.addUrl = "/species/list/drop_down";
          
            (await this.commonService.postApi(this.addUrl,this.loadspeciesValue)).subscribe(
              res => {
                this.speciesloaddata=res.data;
                this.speciesIDprepop=res.data.speciesID
                console.log(this.speciesIDprepop)
                setTimeout(function () {
                  $("#speciesid").val(speciesid)
                  $("#speciesid .filter-option").text(speciesname)
                  $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
               }, 1500);
              })
    


//select farm load species
$('#farmname').change(async ()=> {
  if($('#farmname').val().length===0){
    console.log("loaded value")

  }else{
    this.selectallvalue= $('#farmname').val();
  }
    var farmvalue="";
farmvalue = this.selectallvalue;
this.loadspeciesValue = {
"farms_id":farmvalue.toString()
};
console.log(this.loadspeciesValue.farms_id)
      //species load in select dropdown based on farm select api call
     // this.addUrl = "/species/farms";
  this.addUrl = "/species/list/drop_down";
    
      (await this.commonService.postApi(this.addUrl,this.loadspeciesValue)).subscribe(
        res => {
          this.speciesloaddata=res.data;
          console.log( this.speciesloaddata)
          
          setTimeout(function () {
            $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
         }, 1500);
         

        })
      
  });
//

///////////////////code need to change here...................
      
        /*  var getfarmid= res.data.farm_id.split(",");
          console.log(getfarmid);
              setTimeout(function () {  
                for(var i=0;i<getfarmid.length;i++){
                var optionVal = getfarmid[i];
                console.log(optionVal);
                console.log(res.data.can_delete);
                if(res.data.can_delete!=0){
                  //$("#farmname").find("option[value="+optionVal+"]").attr('style',  'pointer-events: none');
                  // $("#farmname").find("option[value="+optionVal+"]").prop("selected", "selected").attr('style',"background-color:black");
                  $("#farmname").find("option[value="+optionVal+"]").prop("selected", "selected").attr('style',  'pointer-events: none');
                }else{
                  $("#farmname").find("option[value="+optionVal+"]").prop("selected", "selected");
                }
                
            }
            $("#farmname").multiselect('refresh'); 
              }, 1000);*/

///////////////////code need to change here...................
          
           // $("#farmname .filter-option").text(res.data.farm_name)
           // $("select[name=farmname]").val(res.data.farm_id)
    
        console.log(res.data);

        $("#editbreedname").val(res.data.name)
       // $("#speciesid").val(res.data.name)
       $("#breedid").val(res.data.breedID)
       // $("select[name=farmname]").val(res.data.farm_id)
        //$("select[name=breedsEditFamName]").val(res.data.family_name)
        $("select[name=breedsEditStatus]").val(res.data.status)
//        $( "#speciesEditId option:selected" ).text();
$('.selectpicker').selectpicker('refresh');


//$("#speciesEditFamName .filter-option").text(res.data.family_name)
$("#breedsEditStatus .filter-option").text(res.data.status)
       // $("#speciesEditFamName option:selected").val(res.data.family_name)
        if(res.data.status === 1){
          $("#breedsEditStatus option:selected").val('Active')        
        } else {
          $("#breedsEditStatus option:selected").val('Inactive')
        }
      })
        $( "#speciesid" ).change(function() {
          $('.myFakeClassselect').dropdown('toggle');
        });
      
  
  }
  editstatusvalue(){
    $('.breedfak').dropdown('toggle');
  }
  async farmbasedonspecies(event){
    this.speciesprimaryid=event.target.value
    this.loadspeciesValue={
      "farms_id":this.speciesprimaryid
    }
    this.addUrl = "/species/list/drop_down";
    (await this.commonService.postApi(this.addUrl,this.loadspeciesValue)).subscribe(
      res => {
        this.speciesloaddata=res.data;
      })
      setTimeout(function () {
        $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
     }, 1000);
}
  //breeds species validation
  async getspeciesvalue(e){
    console.log(e.currentTarget.options[e.currentTarget.options.selectedIndex].id)
    /* $('#select_all').click(function() {
       $('#countries option').prop('selected', true);
   });*/
    this.getfarmdata= $('#farmname').val();
  // var res = e.target.value.split("and");
   //var speciesid=res[1];
   var getval=e.currentTarget.options[e.currentTarget.options.selectedIndex].id.trim()
   console.log(getval)
   this.getfarmlistApi="/species/species/"+getval;
   (await this.commonService.getApi(this.getfarmlistApi)).subscribe(
     (res) => {
     console.log('test');
     console.log(this.speciesloaddata);
     console.log('test');

    console.log(res.data[0].farm_id);
    var selectedspeciesfarmid=res.data[0].farm_id;
    var resultarryfarmid=selectedspeciesfarmid.split(',');
    console.log(resultarryfarmid)
   console.log(this.getfarmdata)
   /*var resunmatchid =this.getfarmdata.filter( function(n) {  this.has(n) }, new Set(resultarryfarmid) );
   console.log(resunmatchid)*/
   let concat = this.getfarmdata.concat(resultarryfarmid) 
   
   //find same occurence
   let findDuplicates = concat => concat.filter((item, index) => concat.indexOf(item) != index)
  //  this.farmidhavesamespecies=([...new Set(findDuplicates(concat))])
   console.log(this.farmidhavesamespecies)
   var clean_array = $.map(concat.sort(), function (v,i) {
     concat[i] === concat[i+1] && (concat[i] = concat[i+1] = null);
     return concat[i];
   });
   //
   let concatinateforalert = this.getfarmdata.concat(this.farmidhavesamespecies) 
   var clean_array1 = $.map(concatinateforalert.sort(), function (v,i) {
     concatinateforalert[i] === concatinateforalert[i+1] && (concatinateforalert[i] = concatinateforalert[i+1] = null);
     return concatinateforalert[i];
   });
   console.log(clean_array1)
   //
   
   var a = clean_array1
   var resultparseint = a.map(function (x) { 
     return parseInt(x); 
   });
   console.log(resultparseint)
   var getunmatchedfarm=this.getfarmlistdata.filter(function(x){ return this.has(x.tnfr_id)},  new Set(resultparseint));
   console.log(getunmatchedfarm);
   this.result = "";
   for(var i=0;i<getunmatchedfarm.length;i++){
     this.result +="This species doesn't added to "+getunmatchedfarm[i].tnfr_name+" Farm"+"<br>"
   }
   console.log(this.result);
   if(this.result){
     Swal.fire("Wrong Species Selection",this.result);
   }
   
   
   })
   }
  //-------------

 async breedsmanagement(){
  var speciesid=$("#speciesid").val();
  //var res=speciesid.split("and");
  //console.log(res);
 // var clrspc=res[0];
  var getval=speciesid.trim();
  console.log(getval)

  var myArray=this.farmidhavesamespecies.toString();
  if(myArray){
    var farmid=myArray;
  }else{
    var farmid=this.speciesloadid;
  }

 //var farmvalue=$("#farmname").val().toString()

    this.editbreedsFormValue = {
      "name":$("#editbreedname").val(),
      "breedID":$("#breedid").val(),
      "species_id":getval,
       "is_active":1,
       "farm_id":farmid,
     // "farmname":$("#farmname").val(),
      "status":$("#editstatus").val(),
      "cby":this.cby_mby,
      "mby":this.cby_mby
  };
  if(this.farmidhavesamespecies.length!==null){
 (await this.commonService.putApi(this.putbreedseditApi,this.editbreedsFormValue)).subscribe(
      data => {
          alert("Data edited Successfully");
      });
  
      setTimeout(
        () : void => {

          this.router.navigate([this.returnUrl]);

        },
        500
      );
    }else{
      alert("Enter the correct species name")
      }
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
